/* eslint-disable import/no-extraneous-dependencies */
import React from "react"

export const ReactQueryDevtools =
  // eslint-disable-next-line no-undef
  import.meta.env.PROD
    ? () => null
    : React.lazy(() =>
        import("@tanstack/react-query-devtools").then((res) => ({
          default: res.ReactQueryDevtools,
        }))
      )
